(() => {
  const script = document.querySelector('script[data-solaia-gallery-controls]');
  if (!script) return;
  const labels = script.dataset;
  const labelButton = (button, direction) => {
    const label = button.getAttribute('aria-label') || labels[direction];
    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = direction === 'previous' ? '←' : '→';
    const text = document.createElement('span');
    text.textContent = label;
    button.replaceChildren(...(direction === 'previous' ? [arrow, text] : [text, arrow]));
  };
  const arrange = dialog => {
    if (dialog.dataset.solaiaControls) return;
    const stage = dialog.querySelector('.sq-stage');
    const previous = dialog.querySelector('[data-prev]');
    const next = dialog.querySelector('[data-next]');
    const status = dialog.querySelector('.sq-status');
    if (!stage || !previous || !next || !status) return;
    dialog.dataset.solaiaControls = 'true';
    const controls = document.createElement('div');
    controls.className = 'sq-image-controls';
    labelButton(previous, 'previous');
    labelButton(next, 'next');
    controls.append(previous, status, next);
    stage.after(controls);
  };
  const cushionGallery = root => {
    if (root.dataset.solaiaReady) return;
    const entries = [...root.querySelectorAll('.sc-gallery__grid article')].map(card => ({
      link: card.querySelector('a'),
      image: card.querySelector('a img'),
      title: card.querySelector('h2')?.textContent.trim()
    })).filter(entry => entry.link && entry.image);
    if (!entries.length) return;
    root.dataset.solaiaReady = 'true';
    const dialog = document.createElement('dialog');
    dialog.className = 'sq-dialog';
    dialog.setAttribute('aria-label', root.querySelector('h1')?.textContent || '');
    const header = document.createElement('header');
    const title = document.createElement('h2');
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'sq-close'; close.textContent = '×';
    close.setAttribute('aria-label', labels.close);
    header.append(title, close);
    const stage = document.createElement('div'); stage.className = 'sq-stage';
    const image = document.createElement('img'); image.className = 'sq-large';
    image.width = 1254; image.height = 1254; image.alt = '';
    const previous = document.createElement('button'); previous.type = 'button'; previous.className = 'sq-arrow'; previous.dataset.prev = ''; previous.setAttribute('aria-label', labels.previous);
    const next = document.createElement('button'); next.type = 'button'; next.className = 'sq-arrow'; next.dataset.next = ''; next.setAttribute('aria-label', labels.next);
    stage.append(previous, image, next);
    const status = document.createElement('p'); status.className = 'sq-status'; status.setAttribute('aria-live', 'polite');
    dialog.append(header, stage, status); root.append(dialog);
    let index = 0; let opener;
    const show = nextIndex => {
      index = (nextIndex + entries.length) % entries.length;
      const entry = entries[index];
      image.src = entry.link.href; image.alt = entry.image.alt; title.textContent = entry.title;
      status.textContent = `${labels.imageLabel} ${index + 1} / ${entries.length}`;
    };
    entries.forEach((entry, i) => entry.link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); opener = entry.link; show(i); dialog.showModal();
    }));
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowLeft' ? -1 : 1)); }
    });
    dialog.addEventListener('close', () => { image.removeAttribute('src'); opener?.focus(); });
  };
  const init = () => {
    document.querySelectorAll('.sc-gallery').forEach(cushionGallery);
    document.querySelectorAll('.sq-dialog').forEach(arrange);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
